import { render, staticRenderFns } from "./GBPhotoAlbumContentHeader.vue?vue&type=template&id=464948e7&scoped=true&"
import script from "./GBPhotoAlbumContentHeader.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumContentHeader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GBPhotoAlbumContentHeader.vue?vue&type=style&index=1&id=464948e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464948e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VLayout,VProgressCircular})
